// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","dropdown":"styles_dropdown__YQG33","select":"styles_select__yNlim","apply":"styles_apply__cmLtg","actions":"styles_actions__FZiK8"};